import styled from 'styled-components';

export const CardContainer = styled.div<{
  visible: boolean;
}>`
  cursor: pointer;
`;
